export default ["M1 16h14c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1H1C.45 0 0 .45 0 1v14c0 .55.45 1 1 1zM2 2h12v12H2V2zm7 11h4V3H9v10z"];
//# sourceMappingURL=panel.js.map